// plugins目录在vue根实例创建之前执行
// 通过插件使用全局组件

import Vue from 'vue'
import header from '_c/global/header.vue'
import footer from '_c/global/footer.vue'
import noData from '_c/global/no-data'
import sendCode from '_c/global/send-code'
import prompt from '_c/prompt'
import SellerCenterTitle from '_c/global/seller-center-title.vue'
import WangEditor from '_c/global/WangEdit'
import ImageList from '_c/global/ImageList.vue'
import DateRangeFilter from '_c/global/DateRangeFilter.vue'
import JsonExcel from 'vue-json-excel'
const components = {
  'my-header': header,
  'my-footer': footer,
  'no-data': noData,
  WangEditor,
  sendCode,
  Prompt: prompt,
  SellerCenterTitle,
  ImageList,
  DateRangeFilter,
  JsonExcel
}

Object.entries(components).forEach(([name, component]) => {
  Vue.component(name, component)
})
